import {
  SET_HIDDEN,
  FETCHED_PAIRS,
  FETCHED_MATCHED_PAIRS,
  FETCHED_ORDERS,
  FETCHED_SUB_DEMAND_OFFERS,
  FETCHED_MY_ORDERS,
  FETCHED_MATCHED_ORDERS,
  FETCHED_MY_MATCHED_ORDERS,
  FETCHED_PAST_ORDERS,
  FETCHED_MY_PAST_ORDERS,
  FETCHED_MY_MAKER_MAP,
  FETCHED_STATS,
  ADD_TO_MAKER_MAP,
  FETCHED_MAKER_MAP,
  FETCHED_MY_UNMATCHED_ORDERS,
  REMOVE_WALLET
} from '../actions/types';
import {differenceWith} from 'ramda';
import M from 'materialize-css/dist/js/materialize.min.js'
import {pairs} from '../config';
import {Decimal} from 'decimal.js'
var hash = require('object-hash');

let stats = window.getStorage(`bc-stats`)

if(!stats || (stats && stats.time + 1000 * 60 * 60 < Date.now())){
  stats = JSON.parse(JSON.stringify(pairs))
}

let my_maker_map = {}
let all_orders = [];
let latestHeight = 0;

if(window.getStorage(`my_maker_map`)){
  // my_maker_map = window.getStorage(`my_maker_map`)
}
if(window.getStorage(`my_orders`)){
  // all_orders = window.getStorage(`my_orders`)
}
if(window.getStorage(`last_height`)){
  // latestHeight = window.getStorage(`last_height`)
}

let my_orders = [];
let my_unmatched_orders = [];
all_orders.map((o)=>{
  if((o.tradeHeight + o.deposit <= latestHeight)){
    my_unmatched_orders.push(o)
  }
  else my_orders.push(o)
})

let initialState = {
  pairs,
  matched_pairs: pairs,
  maker_map: {},
  my_maker_map,
  all_orders,

  firstCallDone: false,

  orders: [],
  matched_orders: [],

  sub_demand: [],
  sub_offers: [],

  my_orders,
  my_unmatched_orders,
  my_matched_orders: [],

  past_orders: [],
  my_past_orders: [],

  stats,
}

let sortFunc = ((a,b)=> {
  if(new Decimal(a.maker.tradeHeight).lt(new Decimal(b.maker.tradeHeight))) return -1;
  else if(new Decimal(a.maker.tradeHeight).gt(new Decimal(b.maker.tradeHeight))) return 1;
  else {
    return (new Decimal(a.taker.totalCollateral).gte(new Decimal(b.taker.totalCollateral))) ? -1 : 1;
  }
})

export default function(state: Object = initialState, action) {
  let data = action.payload;
  switch(action.type) {
    case ADD_TO_MAKER_MAP:
      let maker_map = state.maker_map
      let o = action.payload;
      maker_map[`${o.txHash}.${o.txOutputIndex}`] = o;
      return {...state,maker_map}
    case FETCHED_MAKER_MAP:
      maker_map = {}
      action.payload.map((o)=>{
        maker_map[`${o.txHash}.${o.txOutputIndex}`] = o;
      })
      return {...state, maker_map}
    case FETCHED_PAIRS:
      return {...state, pairs: data}
    case FETCHED_MATCHED_PAIRS:
      return {...state, matched_pairs: data}
    case FETCHED_STATS:
      data.time = Date.now()
      window.setStorage('bc-stats',JSON.stringify(data))
      return {...state, stats: data};
    case SET_HIDDEN:
      return {...state, hidden: data};
    case FETCHED_ORDERS:
      return { ...state, orders: data};
    case FETCHED_SUB_DEMAND_OFFERS:
      // console.log({action})
      // console.log('calling hash');
      return {...state, sub_demand: data.demand, sub_offers: data.offers,sub_demand_hash:hash(data.demand),sub_offers_hash:hash(data.offers)}
    case FETCHED_MY_MAKER_MAP:
      let my_orders = [];
      let my_unmatched_orders = [];
      data.orders.map((o)=>{
        if((o.tradeHeight + o.deposit <= data.latestHeight)){
          my_unmatched_orders.push(o)
        }
        else my_orders.push(o)
      })
      window.setStorage(`my_maker_map`, JSON.stringify(data.maker_map))
      window.setStorage(`my_orders`, JSON.stringify(data.orders))
      window.setStorage(`last_height`, JSON.stringify(data.latestHeight))
      return {...state,  my_orders, my_unmatched_orders,all_orders:data.orders};
    case FETCHED_MY_UNMATCHED_ORDERS:
      return {...state,  my_unmatched_orders: data};
    case FETCHED_MATCHED_ORDERS:
      return { ...state, matched_orders:data}
    case FETCHED_MY_MATCHED_ORDERS:
      data.sort(sortFunc)
      return { ...state, my_matched_orders: data,firstCallDone:true};
    case FETCHED_PAST_ORDERS:
      return {...state,  past_orders: data};
    case FETCHED_MY_PAST_ORDERS:
      data.sort(sortFunc)
      return { ...state, my_past_orders: data};
    case REMOVE_WALLET:
      return { ...state, my_past_orders:[],my_matched_orders:[],my_orders:[]}
    default:
      return state;
  }
}
